import { render, staticRenderFns } from "./InformativeCard.vue?vue&type=template&id=8de207ee&scoped=true"
import script from "./InformativeCard.vue?vue&type=script&lang=js"
export * from "./InformativeCard.vue?vue&type=script&lang=js"
import style0 from "./InformativeCard.vue?vue&type=style&index=0&id=8de207ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de207ee",
  null
  
)

export default component.exports